const ADMIN_MATCHS_FORM_STORAGE_KEY = "adminMatchs.creationForm";

type StoredCreationForm = {
  boardId?: string;
  roundId?: string;
};

export function readAdminMatchsCreationForm(): {
  boardId: string;
  roundId: string;
} {
  try {
    const raw = sessionStorage.getItem(ADMIN_MATCHS_FORM_STORAGE_KEY);
    if (!raw) {
      return { boardId: "", roundId: "" };
    }
    const parsed = JSON.parse(raw) as StoredCreationForm;
    return {
      boardId: parsed.boardId ?? "",
      roundId: parsed.roundId ?? "",
    };
  } catch {
    return { boardId: "", roundId: "" };
  }
}

export function writeAdminMatchsCreationForm(
  boardId: string,
  roundId: string
): void {
  sessionStorage.setItem(
    ADMIN_MATCHS_FORM_STORAGE_KEY,
    JSON.stringify({ boardId, roundId })
  );
}
